import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, isRef as _isRef, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "app-page app-page--no-shrink app-page--panel prevent-close" }
const _hoisted_2 = {
  key: 0,
  class: "details-panel__content details-panel__content--center details-panel__content--overlay"
}
const _hoisted_3 = {
  key: 1,
  class: "details-panel__content details-panel__content--center details-panel__content--overlay"
}

import NoDataSvg from '@/assets/no-data.svg';
import NoDataDarkSvg from '@/assets/no-data-dark.svg';

// Components
import VLoader from '../components/VLoader.vue';
import VIllustration from '../components/VIllustration.vue';
import { Pane as VPane } from 'splitpanes';
import DetailsPanelTask from './DetailsPanelTask.vue';
import DetailsPanelNumeric from './DetailsPanelNumeric.vue';

// Other
import { hasParentWithClassName, isClickOnScrollbar } from '@/utils/dom-utils';
import { ref, onMounted, Component } from 'vue';

import Storages from '@/core/Storages';
import Settings from '@/core/Settings';
import { useRoute, useRouter } from 'vue-router';
import { computed, markRaw } from '@vue/reactivity';
import { onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'DetailsPanel',
  setup(__props) {

// Svg
const panels = {
    task: markRaw(DetailsPanelTask),
    numeric: markRaw(DetailsPanelNumeric),
};
const panelKeys = Object.keys(panels);

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

let el = ref(null as HTMLDivElement | null);
let noData = ref(false);
let loading = ref(true);
let options = markRaw({} as Record<string, unknown>);

const panelWidth = computed(Storages.Settings.computedDebounce(Settings.UI.PanelWidth, 50));
const theme = computed(() => Storages.Settings.get(Settings.UI.Theme));

const panelComponent = computed((): Component | undefined => {
    const key = panelKeys.find((key) => !!route.query[key]) as keyof typeof panels | undefined;
    return key ? panels[key] : undefined;
});
const visible = computed((): boolean => !!panelComponent.value);

onMounted(() => {
    document.addEventListener('mousedown', onDocumentClick);
});

onBeforeUnmount((): void => {
    document.removeEventListener('mousedown', onDocumentClick);
});

function close(force = false): void {
    if (typeof options.close === 'function') {
        options.close(force);
        return;
    }

    router.replace({ query: {} });
}

function configure($options: Record<string, unknown>) {
    options = markRaw($options);
}

function onDocumentClick(event: MouseEvent): void {
    if (!visible.value) {
        return;
    }

    const element = event.target as HTMLElement;

    let stopCloseEvent = isClickOnScrollbar(event);
    if (stopCloseEvent) {
        return;
    }

    stopCloseEvent = hasParentWithClassName(element, ['prevent-close', 'splitpanes__splitter']);
    if (stopCloseEvent) {
        return;
    }

    close(true);
}

function resetOptions() {
    options = {};
}

function random(min: number, max: number) {
    return Math.round(Math.random() * (max - min) + min);
}

return (_ctx: any,_cache: any) => {
  return (_unref(visible))
    ? (_openBlock(), _createBlock(_unref(VPane), {
        key: 0,
        ref_key: "el",
        ref: el,
        class: _normalizeClass(["splitpanes__pane--sidebar splitpanes__pane--shadow details-panel", {
            'splitpanes__pane--fixed': _ctx.$device.isMobile,
        }]),
        "max-size": "80",
        "min-size": "35",
        size: _ctx.$device.isMobile ? 100 : _unref(panelWidth)
      }, {
        default: _withCtx(() => [
          _createElementVNode("aside", _hoisted_1, [
            (_unref(loading))
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(VLoader, { class: "loader--mini loader--center" })
                ]))
              : _createCommentVNode("", true),
            (_unref(noData))
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(VIllustration, {
                    tip: _unref(t)('no-data-' + random(0, 5))
                  }, {
                    default: _withCtx(() => [
                      (_unref(theme) === 'light')
                        ? (_openBlock(), _createBlock(_unref(NoDataSvg), { key: 0 }))
                        : (_unref(theme) === 'dark')
                          ? (_openBlock(), _createBlock(_unref(NoDataDarkSvg), { key: 1 }))
                          : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["tip"])
                ]))
              : _createCommentVNode("", true),
            _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(_unref(panelComponent)), {
              onBeforeUnmount: resetOptions,
              onClose: close,
              onConfigure: configure,
              onLoading: _cache[0] || (_cache[0] = ($event: any) => (_isRef(loading) //@ts-ignore
 ? loading.value = $event : loading = $event)),
              onNoData: _cache[1] || (_cache[1] = ($event: any) => (_isRef(noData) //@ts-ignore
 ? noData.value = $event : noData = $event))
            }, null, 544)), [
              [_vShow, !_unref(loading) && !_unref(noData)]
            ])
          ])
        ]),
        _: 1
      }, 8, ["class", "size"]))
    : _createCommentVNode("", true)
}
}

})